import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DEFAULT_LOCALE, ReportCardGroup } from '@app/shared/constants';
import { LoggerService } from '@app/shared/services/logger.service';
import { ReportsService } from '@app/shared/services/reports.service';
import { formatNumber } from '@angular/common';
import { Sort } from '@angular/material/sort';
import { HelpersService } from '@app/shared/services/helpers.service';

@Component({
  standalone: false,
  selector: 'app-machool-report-top-revenue',
  templateUrl: './machool-report-top-revenue.component.html',
})
export class MachoolReportTopRevenueComponent implements OnInit {
  @Input() filterForm: FormGroup | undefined;
  @Input() range: FormGroup | undefined;

  public loading = true;

  public loadingTopRevenue = false;
  public loadingTopRevenueFailed = false;
  public topRevenueAccounts: any[];
  public sortedTopRevenueAccounts: any[];
  public topRevenueAccountsEmpty: boolean = false;
  public topRevenueColumns = ['index', 'companyName', 'totalShipments', 'revenue', 'salesRep'];

  constructor(
    private logger: LoggerService,
    private helpersService: HelpersService,
    private reportsService: ReportsService,
  ) {}

  ngOnInit() {
    this.getTopRevenueList();
  }

  public sortData(sort: Sort) {
    const data = this.topRevenueAccounts.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedTopRevenueAccounts = data;
      return;
    }
    const isAsc = sort.direction === 'asc';
    this.sortedTopRevenueAccounts = data.sort((a, b) => {
      return this.helpersService.compare(a[sort.active], b[sort.active], isAsc);
    });
  }

  public getTopRevenueList(): void {
    this.loadingTopRevenue = true;
    this.loadingTopRevenueFailed = false;
    let query: any = this.reportsService.getFilterQuery(this.range, this.filterForm);
    query.report_card_group = ReportCardGroup.TOP_REVENUE;
    this.reportsService.getSummaryCard(query).subscribe(
      (res) => {
        this.topRevenueAccounts = [];
        res.accounts.forEach(account => {
          this.topRevenueAccounts.push({
            companyName: account.companyName,
            totalShipmentsFormatted: formatNumber(account.total, DEFAULT_LOCALE),
            totalShipments: Number(account.total),
            revenue: parseFloat(account.revenue),
            salesRep: account.salesRep,
            isSigneLocal: account.isSigneLocal === "true",
          });
        })
        this.topRevenueAccountsEmpty = this.topRevenueAccounts.length === 0;
        this.sortData({active: 'revenue', direction: 'desc'});
        this.loadingTopRevenue = false;
      },
      (err: Error) => {
        this.loadingTopRevenue = false;
        this.loadingTopRevenueFailed = true;
        this.logger.error('GET top accounts report error', err);
      }
    );
  }
}
